import DevelopmentProcess from '../../component/layout/developmentprocess'
import Technologies from '../../component/layout/technology'
import Contact from '../../component/layout/contact-form'
import SEO from '../../component/util/SEO'
import FAQ from '../../component/layout/faq'

function AboutUS() {

  return (
    <main className="night-theme pb-5">
      <SEO
        title="About Us BringIt Go"
        description="Learn about BringIt Go, a UK technology company building web applications, UI/UX design, cloud infrastructure, mobile apps, and blockchain solutions."
        canonical="https://www.bringitgo.tech/about-us"
        keywords="about BringIt Go, UK web development company, software development company, technology services"
      />
      <DevelopmentProcess />
      <Technologies />
      <FAQ />
      <Contact />
    </main>
  )
}

export default AboutUS
